export const langList = [
  { label: "英", value: "en" },
  { label: "日", value: "js" },
  { label: "繁体", value: "zh-TW" },
  { label: "西语", value: "es" },
  { label: "葡语", value: "pt" },
  { label: "俄语", value: "ru" },
  { label: "德语", value: "de" },
  { label: "法语", value: "fr" },
  { label: "意语", value: "it" },
  { label: "越南语", value: "vi" },
  { label: "印尼语", value: "id" },
  { label: "波兰语", value: "pl" },
  { label: "匈牙利语", value: "hu" },
  { label: "中文", value: "zh" },
];

export const productionTypeList = [
  { label: "剪辑", value: "剪辑" },
  { label: "动画", value: "动画" },
  { label: "psd", value: "psd" },
  { label: "改尺寸", value: "改尺寸" },
  { label: "改语言", value: "改语言" },
  { label: "换背景", value: "换背景" },
];
export const headerList = [
  { label: "时间", value: "createTime", width: "6%" },
  { label: "玩法名称", value: "appName", width: "22%" },
  { label: "创意来源", value: "creativeSource", width: "10%" },
  { label: "设计人", value: "materialDesigner", width: "8%" },
  { label: "制作人", value: "materialProductor", width: "8%" },
  { label: "制作时长", value: "productTime", width: "8%" },
  { label: "需求状态", value: "demandStatus", width: "8%" },
  { label: "需求截止时间", value: "deadline", width: "10%" },
  { label: "素材综合效果", value: "materialEffect", width: "10%" },
];
export const materialEffectList = [
  { label: "全部素材综合效果", value: -1 },
  { label: "有效", value: 2 },
  { label: "有效+", value: 3 },
  { label: "带量", value: 4 },
];
export const channelList = [
  { label: "FB", value: "FB" },
  { label: "GG", value: "GG" },
  { label: "TT", value: "TT" },
  { label: "unity", value: "unity" },
  { label: "mintegral", value: "mintegral" },
  { label: "今日头条", value: "toutiao" },
  { label: "微信", value: "wechat" },
  { label: "广点通", value: "tencent" },
  { label: "快手", value: "kuaishou" },
  { label: "素材综合效果", value: "materialEffect" },
];
